import React from "react";
import "../styles/wc.css";

export default function EvidenceChips({ dsoDelta = 0, dioDelta = 0, dpoDelta = 0, cccDelta = 0, ocfDirection }) {
    const sym = (v) => (v < 0 ? "↓" : v > 0 ? "↑" : "→");

    // Determine if change is good or bad for cash flow
    // DSO/DIO down = good (less cash tied up), DPO up = good (paying slower)
    const getChipStyle = (metric, delta) => {
        let isGood = false;
        if (metric === 'DSO' || metric === 'DIO') {
            isGood = delta < 0; // Lower is better
        } else if (metric === 'DPO') {
            isGood = delta > 0; // Higher is better (paying slower)
        } else if (metric === 'CCC') {
            isGood = delta < 0; // Lower is better (faster cash conversion)
        }

        return {
            backgroundColor: isGood ? 'var(--surface-success)' : 'var(--surface-danger)',
            borderColor: isGood ? 'var(--surface-success-border)' : 'var(--surface-danger-border)',
            color: isGood ? 'var(--surface-success-text)' : 'var(--surface-danger-text)'
        };
    };

    const Chip = ({ label, value, delta, metric }) => (
        <div className="wc-chip" style={getChipStyle(metric, delta)}>
            <strong>{label}</strong>: {value}
        </div>
    );

    return (
        <div className="wc-chiprow">
            {typeof ocfDirection === "number" && (
                <Chip label="OCF" value={ocfDirection > 0 ? "↑" : ocfDirection < 0 ? "↓" : "→"} delta={ocfDirection} metric="OCF" />
            )}
            <Chip
                label="DSO"
                value={`${sym(dsoDelta)}${Math.abs(dsoDelta).toFixed(0)}d`}
                delta={dsoDelta}
                metric="DSO"
            />
            <Chip
                label="DIO"
                value={`${sym(dioDelta)}${Math.abs(dioDelta).toFixed(0)}d`}
                delta={dioDelta}
                metric="DIO"
            />
            <Chip
                label="DPO"
                value={`${sym(dpoDelta)}${Math.abs(dpoDelta).toFixed(0)}d`}
                delta={dpoDelta}
                metric="DPO"
            />
            <Chip
                label="CCC"
                value={`${sym(cccDelta)}${Math.abs(cccDelta).toFixed(0)}d`}
                delta={cccDelta}
                metric="CCC"
            />
        </div>
    );
}
